export const durationBarComponentName = 'VjsDurationInfoBar';

export const videoPlayButtonComponentName = 'vjsBigPlayButton';
